export default __webpack_public_path__ + "static/media/zoomin.91cb4b8b.svg";